import { COLORS } from '@/styles/tokens/colors';

/**
 * Shared treatment for the xs icon buttons in chat surface headers — the chat
 * column header and the side content panel header. Primary navy icons (the
 * transparent variant's default gray is too light for the header per design),
 * scoped to :not(:disabled) with an explicit hover override so the disabled
 * state keeps the variant's lighter gray. The padding tightens the xs square
 * button's 5px to 4px, keeping the buttons 24px tall so headers sitting side
 * by side render the same height with aligned bottom borders.
 */
export const CHAT_HEADER_ICON_BUTTON_SX = {
  padding: '4px',
  '&:not(:disabled)': {
    color: COLORS.TEXT.PRIMARY,
    '&:hover': {
      color: COLORS.TEXT.PRIMARY,
    },
  },
};
